import axios, { AxiosPromise, AxiosRequestConfig } from "axios";

const hogaApi = axios.create();

export interface HogaApi {
    post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): AxiosPromise<T>;
}

export class AlwaysPassingHogaApi implements HogaApi {
    private lastCall = {
        url: "",
        data: null
    };
    constructor(private response: any) { }

    public post(url: string = "", data: any = {}) {
        this.lastCall = {
            url,
            data
        };

        return Promise.resolve(this.response);
    }

    public calledWithUrl() {
        return this.lastCall.url;
    }

    public calledWithData() {
        return this.lastCall.data;
    }
}

export default hogaApi;
